module.exports = __webpack_public_path__ + "media/images/icon/linkedin-239571f56b2f521b306915f1adfe3a25.svg";